module.exports = __webpack_public_path__ + "img/Logo.f5906f39.svg";